<template>
<span>
  <AddPaymentMethod />

  <v-list v-if="hasItems" two-line class="pa-0">
    <div v-for="(paymentMethod, index) in getPaymentMethods" :key="`method_${index}`" id="PaymentMethodItem">
      <v-divider v-if="index" />
      <PaymentMethodItem :payment-method="paymentMethod" />
    </div>
  </v-list>
  <div v-else class="headline my-3">
    {{ $vuetify.t('$vuetify.account.noPaymentMethods') }}
  </div>
</span>
</template>

<script>
  import AddPaymentMethod from '@/components/Account/AddPaymentMethod.vue'
  import PaymentMethodItem from '@/components/Account/PaymentMethodItem.vue'

  import { mapGetters } from 'vuex'

  export default {
    components: {
      AddPaymentMethod,
      PaymentMethodItem
    },

    computed: {
      hasItems() {
        return Array.isArray(this.getPaymentMethods) && this.getPaymentMethods.length > 0
      },

      ...mapGetters([ 'getPaymentMethods' ])
    }
  }
</script>
